/** Щелчок дерева: синтез WebAudio по эталону, файлов нет. */
const KEY = 'bc:sound';

let ac: AudioContext | null = null;
let enabled = localStorage.getItem(KEY) !== 'off';

export function soundEnabled(): boolean {
  return enabled;
}

export function setSound(on: boolean): void {
  enabled = on;
  localStorage.setItem(KEY, on ? 'on' : 'off');
}

/** strength: 0.14 выделение, 0.32 ход, 0.5 взятие, 0.42 дамка. */
export function click(strength: number): void {
  if (!enabled) return;
  try {
    ac = ac ?? new AudioContext();
    if (ac.state === 'suspended') void ac.resume();
    const dur = 0.055;
    const buf = ac.createBuffer(1, Math.floor(ac.sampleRate * dur), ac.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < d.length; i++) {
      d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 7);
    }
    const src = ac.createBufferSource();
    src.buffer = buf;
    const bp = ac.createBiquadFilter();
    bp.type = 'bandpass';
    bp.frequency.value = 1500 + Math.random() * 500;
    bp.Q.value = 1.6;
    const g = ac.createGain();
    g.gain.value = strength;
    src.connect(bp).connect(g).connect(ac.destination);
    src.start();
  } catch {
    /* звук не критичен */
  }
  if (navigator.vibrate) navigator.vibrate(strength > 0.3 ? 12 : 6);
}
